module.exports = __webpack_public_path__ + "9568258e01174279d52c6f36aa356c8a.jpg";